
import React, { useState } from 'react'
import { message } from 'antd'
import { NavLink, Link } from 'react-router-dom'
import $api, { QueryWordApiResult } from 'sdss/api'
import { QueryWordData } from 'sdss/types/ListArticlesModules'
import { useHistory } from 'react-router-dom'
import styles from './styles.module.scss'
import { SearchRecordPageRoute, SearchPageRoute } from 'sdss/routes/searchPage/searchPage'
import BasicLayout from 'sdss/layouts/BasicLayout'
import { Input } from 'antd'

export function HomeView() {
  const infoBoxData = [
    { title: 'PubMed 文献', count: '3,000W+' },
    { title: 'MeSH 词', count: '29,638' },
    { title: '累计生成图谱', count: '16,313' },
    { title: '用户数', count: '1,634' },
  ]
  // 推荐词列表
  const [searchList, setSearchList] = useState<QueryWordData[]>([])
  // 搜索值
  const [searchValue, setSearchValue] = useState('')
  let history = useHistory()

  /** 触发搜索框 */
  const triggerSearch = (event: React.FocusEvent<HTMLInputElement>) => {
    $api.queryWord()
      .then((res: QueryWordApiResult) => {
        const { code, data, message: msg } = res
        if (code === 0) {
          setSearchList(data)
        } else {
          message.error(msg)
        }
      })
  }

  /** 输入框失去焦点，清空搜索列表 */
  const triggerBlur = () => {
    setTimeout(() => {
      setSearchList([])
    }, 500)
  }

  // 实时搜索
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
    if (searchValue) {
      $api.queryWord()
        .then((res: QueryWordApiResult) => {
          if (res.code === 0) {
            setSearchList(res.data)
          } else {
            message.error(res.message)
          }
        })
    }
  }

  const enterSearch = (e: any) => {
    if (e.keyCode === 13 || e.keyCode === 108) {
      history.replace(`/search/${searchValue}`)
    }
  }

  return (
    <div className={styles.home}>
      <BasicLayout showDefaultBgColor={false} />
      <div className={styles.content} data-flex="dir:top main:justify">
        <div style={{ width: 853, margin: '0 auto' }}>
          <div style={{ marginTop: 'calc(50vh - 145px)', display: 'flex' }}>
            <Input
              type="text"
              placeholder="请输入搜索词"
              value={searchValue}
              onInput={triggerSearch}
              onBlur={triggerBlur}
              onChange={handleChange}
              onKeyUp={enterSearch}
              style={{ width: 753, height: 51, color: '#333', border: 'none', borderRadius: 4, outline: 'none', paddingLeft: 10 }}
            />
            <Link to={searchValue ? SearchPageRoute.formatUrl({ queryWord: searchValue }) : '/'}>
              <button
                style={{
                  width: 100,
                  height: 51,
                  border: 'none',
                  color: '#fff',
                  background: '#1890FF',
                  marginLeft: -2
                }} onClick={() => { if (!searchValue) { message.error('请输入搜索词') } }}>
                搜索
            </button>
            </Link>
          </div>
          <div>
            <NavLink to={SearchRecordPageRoute.formatUrl()}>我的查询历史 &gt;</NavLink>
          </div>
        </div>
        <div data-flex="main:justify" style={{ marginBottom: 70 }}>
          {infoBoxData.map(val => mapDataToInfoBox(val))}
        </div>
      </div>
    </div>
  )
}

export interface InfoBoxProps {
  count: string,
  title: string,
}

function mapDataToInfoBox(props: InfoBoxProps) {
  const { title, count } = props
  return (
    <div className={styles.infoBox} data-flex="dir:top cross:center main:center" key={count}>
      <div className={styles.number}>{count}</div>
      <div className={styles.title}>{title}</div>
    </div>
  )
}
